// extracted by mini-css-extract-plugin
export default {"errorMessage":"ErrorMessage_errorMessage__4OvLD","link":"ErrorMessage_link__Eaw6V"};